module.exports = __webpack_public_path__ + "static/media/CHL.ff592c6b.svg";